import { Button } from '@/components/atoms/Button';
import { Text } from '@/components/atoms/text';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ComparativeContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
  },
}));

export const ComparativeModalHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5, 1.5, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0),
  },
}));

export const ComparativeModalHeaderContent = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const ComparativeModalContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(1.5),
  maxHeight: '560px',
  overflowY: 'auto',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 0),
  },
}));

interface ComparativeModalInputAmountProps {
  disabled?: boolean;
}

export const ComparativeModalInputAmount = styled(Text)<ComparativeModalInputAmountProps>(
  ({ theme, disabled }) => ({
    minWidth: '44px',
    maxWidth: '44px',
    height: '44px',
    borderRadius: '50%',
    backgroundColor: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.primary.main,
    color: disabled ? theme.palette.text.secondary : theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  })
);

export const ComparativeModalEmptyAmount = styled(Box)(({ theme }) => ({
  minWidth: '44px',
  maxWidth: '44px',
  height: '44px',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const ComparativeModalInput = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const ComparativeModalMoreButtonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const ComparativeModalMoreButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '44px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  color: theme.palette.text.primary,
  borderColor: theme.palette.action.active,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.action.active,
  },
}));

export const ComparativeModalButtons = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row-reverse',
  justifyContent: 'flex-start',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: theme.spacing(2, 3),
  },
}));

export const CompareButton = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: '100px',
  height: '44px',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: '100%',
  maxWidth: '100px',
  height: '44px',
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));
